import _ from 'lodash'
import Backbone from 'backbone'
import CalendarList from './calendar-list'
import PeriodList from './period-list'
import calendars from 'scoreboard/components/calendars'
import conductor from 'scoreboard/components/conductor'
import i18n from 'scoreboard/components/i18n'
import DisplayHeader from 'scoreboard/components/display-header'
import template from 'scoreboard/admin/admin-two-column-editor.hbs'
import scrollContainer from 'scoreboard/components/scroll-container'
import TwoColumnDetailsForm from 'scoreboard/components/two-column-details-form'
import mobile from 'scoreboard/components/mobile'
import constants from 'scoreboard/components/constants'

var AdminCalendarsView = Backbone.View.extend({

	className: 'admin admin-calendars admin-list-view two-column-details-form',

	initialize: function(options) {
		this.options = options
		// by default show the first calendar
		if (!this.options.calendarId) {
			var firstCalendar = calendars.calendars && calendars.calendars[0]
			this.options.calendarId = firstCalendar && firstCalendar.id
		}

		this.calendarList = new CalendarList(this.options)
		this.calendarList.on('select:calendar', calendar => {
			this.selectCalendar(calendar)
			this.twoColumnsDetailsForm.resize()
		})
		this.calendarList.on('treeRendered', () => this._resizeCalendarList())

		this.periodList = new PeriodList()
		this.periodList.on('change:calendar', calendar => {
			this.changeCalendar(calendar)
			this.twoColumnsDetailsForm.resize()
		})

		this.on('resize', () => this.twoColumnsDetailsForm.resize())
	},

	render: function() {
		this.$el.empty().append(template())
		// Remove the edit buttons footer because it's not needed here in this view
		this.$('footer').remove()
		this.$('.display-pane-body').before(new DisplayHeader({
			heading: i18n.get('common.calendar.calendars'),
			mobileGearHidden: true
		}).render().el)
		this.$('.admin-list').append(this.calendarList.el)
		this.calendarList.render()
		if (this.options.calendarId) {
			var calendar = calendars.calendarsById[this.options.calendarId]
			this.selectCalendar(calendar)
		}
		this.setupTwoColumnDetailsForm()
		this.twoColumnsDetailsForm.resize()
		return this
	},

	setupTwoColumnDetailsForm: function() {
		this.twoColumnsDetailsForm = new TwoColumnDetailsForm({
			el: this.el,
			getScrollContainer: () => {
				if (mobile.isMobileWidth()) {
					return this.$('.display-layout')
				} else {
					return scrollContainer(this.el)
				}
			},
			autoHeight: true,
			// The tree used here is formatted like a list so we don't want
			// any expanding going on.
			expandTree: false
		})

		if (mobile.isMobileWidth()) {
			scrollContainer(this.el)
				.on('scroll', () => this.twoColumnsDetailsForm.adjustLeftPanelScroll())
		} else {
			this.$('.display-layout')
				.on('scroll', () => this.twoColumnsDetailsForm.adjustLeftPanelScroll())
		}

		this.twoColumnsDetailsForm.on('afterLeftPanelResize', () => this._resizeCalendarList())
	},

	_resizeCalendarList: function() {
		// Nix any preexisting height to invoke the natural height of the panel
		this.$('.left-panel .tree').css('height', '')
		// The results section should take up as much space as the draggable list
		// (tree) needs, but shouldn't be taller than the panel minus the panel-header
		// and finder height.
		var treeHeight = this.calendarList.getTreeHeight()
		var height = Math.min(treeHeight, this._getCalendarListMaxHeight())
		// If the panels are stacked, let the tree flow as tall as it wants
		if (this.twoColumnsDetailsForm.panelsStacked()) {
			this.$('.left-panel .tree').css('height', treeHeight)
		} else {
			this.$('.left-panel .tree').css('height', height)
		}
	},

	_getCalendarListMaxHeight: function() {
		var panelHeaderHeight = this.$('.left-panel .panel-header').outerHeight()
		var availableHeight = scrollContainer(this.el).height() - 2*constants.STANDARD_MARGIN
		return availableHeight - panelHeaderHeight
	},

	selectCalendar: function(calendar) {
		// calendar might be null if there are no calendars defined
		if (calendar) {
			this.$('.admin-display').append(this.periodList.render(calendar).el)
			conductor.navigate('admin/calendars/' + calendar.id)
		}
	},

	changeCalendar: function(calendar) {
		this.calendarList.resetCalendars(calendar)
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.calendarList, this.periodList], 'remove')
	}

})

export default AdminCalendarsView

AdminCalendarsView.__filename__ = 'admin/calendars/admin-calendars.js'
